import React from 'react'
import SucesosSubSections from '../../components/sucesosSubSections';
import { Interno, Interno2 } from '../../assets/sucesosInfo/organizacionNacionalInfo';
import Typography from '@material-ui/core/Typography'
import Link from 'gatsby-link'

const OrganizacionPage = () => (
  <div style={{marginTop: 10}} >
    <Typography variant="title" style={{color: '#3A3380', fontWeight: 'bold', fontSize: '1.2rem'}}>
      1820-1852: Autonomías Provinciales y Organización Nacional | Sección 1 -
      <Link to={'/sucesos/autonomias-organizacion-nacional-2'} style={{color: '#615b99', borderBottom: '2px dashed'}}> Sección 2 </Link>
    </Typography>
    <SucesosSubSections info={Interno} />
    <SucesosSubSections info={Interno2} />
  </div>
)

export default OrganizacionPage


// WEBPACK FOOTER //
// ./src/pages/sucesos/autonomias-organizacion-nacional.js